import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
    Autocomplete,
    CircularProgress,
    Paper,
    createFilterOptions,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Tabs,
    Tab,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { Add, Clear, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import NormalTable from "../../../Component/NormalTable";

const PartsReservationModal = ({ mode, handleCloseClick, editData }) => {
    const [woData, setWOData] = useState([]);
    const [woSel, setWOSel] = useState("");
    const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
    const [reservationItem, setReservationItem] = useState({
        partId: null,
        stockRoomId: null,
        quantity: 0,
        stockRoom: [],
    });
    const [workOrderParts, setWorkOrderParts] = useState([]);
    const [addReservation, setAddReservation] = useState([]);
    const [partSelect, setPartSel] = useState("");
    const [srSelect, setSRSel] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingParts, setLoadingParts] = useState(false);
    const [reservedList, setReservedList] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState({
        open: false,
        pendingValue: null,
        pendingInputValue: "",
        setFieldValue: null,
    });
    const [editReservedId, setEditReservedId] = useState(null);
    const [editReservedQuantity, setEditReservedQuantity] = useState(0);
    const [editReservedStockRoomId, setEditReservedStockRoomId] = useState("");
    const [editReservedStockRoomOptions, setEditReservedStockRoomOptions] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);
        const link = masterAPI["workOrder"].link;
        await axiosPrivate
            .get(`${link}`)
            .then((res) => {
                setLoading(false);
                setWOData(res.data.result);
            })
            .catch(() => {
                setWOData([]);
                setLoading(false);
            });
        setLoading(false);
    };

    const fetchWorkOrderParts = async (workOrderId) => {
        setLoadingParts(true);
        setWorkOrderParts([]);
        try {
            const response = await axiosPrivate.get(
                `${masterAPI?.["workOrder"]?.getWOPartByWOId}/${workOrderId}`
            );
            if (response.data.statusCode === 200) {
                setWorkOrderParts(response.data.result);
            }
        } catch (error) {
            setWorkOrderParts([]);
        } finally {
            setLoadingParts(false);
        }
    };

    const fetchReservedList = async (workOrderId) => {
        setLoading(true);
        setReservedList([]);
        try {
            const response = await axiosPrivate.get(
                `${masterAPI["partsReservation"].getByWorkOrderId}/${workOrderId}`
            );
            if (response.data.statusCode === 200) {
                setReservedList(response.data.result);
            }
        } catch (error) {
            setReservedList([]);
        } finally {
            setLoading(false);
        }
    };

    const defaultFilterOptions = createFilterOptions();
    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
        return <Paper elevation={8} {...props} />;
    };
    const initialValue = {
        workOrderId: mode === "Edit" ? editData.workOrderId : null,
    };
    const onSubmit = async (_) => {
        setLoading(true);
        const createLink = masterAPI["partsReservation"]?.bulkinsert;
        const updateLink = masterAPI["partsReservation"]?.update;
        const payload = addReservation.map(item => ({
            workOrderPartsId: item.workOrderPartsId,
            quantity: Number(item.quantity),
            stockRoomId: item.stockRoomId,
            partId: item.partId,
        }));
        if (mode === "Create") {
            await axiosPrivate
                .post(`${createLink}`, payload)
                .then(() => {
                    setLoading(false);
                    handleCloseClick();
                })
                .catch(() => {
                    setLoading(false);
                });
        } else {
            const updatePayload = {
                id: editData.id,
                items: payload,
            };
            await axiosPrivate
                .put(`${updateLink}`, updatePayload)
                .then(() => {
                    setLoading(false);
                    handleCloseClick();
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };

    const handleWorkOrderChange = (event, value, setFieldValue) => {
        if (addReservation.length > 0 && (value === null || (selectedWorkOrder && value?.id !== selectedWorkOrder?.id))) {
            if (selectedWorkOrder) {
                setWOSel(selectedWorkOrder.code + " - " + selectedWorkOrder.workOrderName);
            } else {
                setWOSel("");
            }
            setConfirmDialog({
                open: true,
                pendingValue: value,
                pendingInputValue: value ? value.code + " - " + value.workOrderName : "",
                setFieldValue: setFieldValue,
            });
        } else {
            if (value !== null) {
                setFieldValue("workOrderId", value.id);
                setSelectedWorkOrder(value);
                setWOSel(value.code + " - " + value.workOrderName);
                fetchWorkOrderParts(value.id);
                fetchReservedList(value.id);
            } else {
                setFieldValue("workOrderId", null);
                setWOSel("");
                setSelectedWorkOrder(null);
                setWorkOrderParts([]);
                setReservedList([]);
            }
        }
    };

    const handleConfirmWorkOrderChange = () => {
        const { pendingValue, pendingInputValue, setFieldValue } = confirmDialog;
        setAddReservation([]);
        setReservationItem({
            partId: null,
            stockRoomId: null,
            quantity: 0,
            stockRoom: [],
        });
        setPartSel("");
        setSRSel("");
        if (pendingValue !== null) {
            setFieldValue("workOrderId", pendingValue.id);
            setWOSel(pendingInputValue);
            setSelectedWorkOrder(pendingValue);
            fetchWorkOrderParts(pendingValue.id);
            fetchReservedList(pendingValue.id);
        } else {
            setFieldValue("workOrderId", null);
            setWOSel("");
            setSelectedWorkOrder(null);
            setWorkOrderParts([]);
            setReservedList([]);
        }
        setConfirmDialog({
            open: false,
            pendingValue: null,
            pendingInputValue: "",
            setFieldValue: null,
        });
    };

    const handleCancelWorkOrderChange = () => {
        if (selectedWorkOrder) {
            setWOSel(selectedWorkOrder.code + " - " + selectedWorkOrder.workOrderName);
        } else {
            setWOSel("");
        }
        setConfirmDialog({
            open: false,
            pendingValue: null,
            pendingInputValue: "",
            setFieldValue: null,
        });
    };

    const handlePart = async (value) => {
        const srLink = masterAPI["selectList"].stockRoomByPart;
        await axiosPrivate
            .get(`${srLink}/${value.partId}`)
            .then((res) => {
                setReservationItem({
                    ...reservationItem,
                    partId: value.partId,
                    workOrderPartsId: value.id,
                    stockRoomId: null,
                    stockRoom: Array.isArray(res.data) ? res.data : [],
                });
            })
            .catch(() => {
                setReservationItem({
                    ...reservationItem,
                    partId: value.partId,
                    workOrderPartsId: value.id,
                    stockRoom: [],
                });
            });
    };

    const handleAddReservation = (e) => {
        const { name, value } = e.target;
        setReservationItem({ ...reservationItem, [name]: value });
    };

    const handleStockRoom = async (value) => {
        setReservationItem({
            ...reservationItem,
            stockRoomId: value.value,
        });
    };

    const handleReservationList = () => {
        const partObj = workOrderParts.find(p => p.partId === reservationItem.partId);
        const stockRoomObj = reservationItem.stockRoom?.find(s => s.value === reservationItem.stockRoomId);
        setAddReservation([
            ...addReservation,
            {
                ...reservationItem,
                quantity: Number(reservationItem.quantity),
                partCode: (partObj?.code ? partObj.code + " - " : "") + (partObj?.partName || ''),
                partName: partObj ? partObj.partName : '',
                stockRoomName: stockRoomObj ? stockRoomObj.text : '',
            }
        ]);
        setReservationItem({
            partId: null,
            stockRoomId: null,
            quantity: 0,
            stockRoom: []
        });
        setPartSel("");
        setSRSel("");
    };

    const partColumn = [
        { Header: "Part", accessor: "partCode" },
        { Header: "Stock Room", accessor: "stockRoomName" },
        { Header: "Quantity", accessor: "quantity" },
        {
            Header: "Action",
            accessor: "partId",
            Cell: ({ cell }) => (
                <>
                    <IconButton>
                        <EditOutlined onClick={() => handlePartEdit(cell)} sx={{ fontSize: color.masterEditDelButton, color: color.masterEditDelButtonColor }} />
                    </IconButton>
                    <IconButton onClick={() => deleteReservation(cell.row.original.partId)}>
                        <DeleteOutlined sx={{ fontSize: color.masterEditDelButton, color: color.masterEditDelButtonColor }} />
                    </IconButton>
                </>
            ),
            disableFilters: true,
        },
    ];

    const handlePartEdit = (cell) => {
        const item = cell.row.original;
        const srLink = masterAPI["selectList"].stockRoomByPart;
        axiosPrivate
            .get(`${srLink}/${item.partId}`)
            .then((res) => {
                setReservationItem({
                    partId: item.partId,
                    stockRoomId: item.stockRoomId,
                    quantity: item.quantity,
                    workOrderPartsId: item.workOrderPartsId,
                    stockRoom: Array.isArray(res.data) ? res.data : [],
                });
            })
            .catch(() => {
                setReservationItem({
                    partId: item.partId,
                    stockRoomId: item.stockRoomId,
                    quantity: item.quantity,
                    workOrderPartsId: item.workOrderPartsId,
                    stockRoom: [],
                });
            });
        setPartSel(item.partCode);
        setSRSel(item.stockRoomName);
        setAddReservation(addReservation.filter((r) => r.partId !== item.partId));
    };

    const deleteReservation = (id) => {
        const delReservation = addReservation.filter((fil) => fil.partId !== id);
        setAddReservation(delReservation);
    };

    const handleCancel = () => {
        handleCloseClick();
    };

    const handleReservedEdit = (item) => {
        setEditReservedId(item.id);
        setEditReservedQuantity(item.quantity);
        setEditReservedStockRoomId(item.stockRoomId);
        const srLink = masterAPI["selectList"].stockRoomByPart;
        axiosPrivate.get(`${srLink}/${item.partId}`)
            .then((res) => {
                setEditReservedStockRoomOptions(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                setEditReservedStockRoomOptions([]);
            });
    };

    const handleReservedSave = async (item) => {
        const payload = {
            id: item.id,
            workOrderPartsId: item.workOrderPartsId,
            quantity: Number(editReservedQuantity),
            stockRoomId: editReservedStockRoomId,
            partId: item.partId,
        };
        try {
            await axiosPrivate.put(masterAPI["partsReservation"].update, payload);
            setReservedList(reservedList.map(r => r.id === item.id ? { ...r, quantity: payload.quantity, stockRoomId: payload.stockRoomId } : r));
            setEditReservedId(null);
        } catch (error) {
        }
    };

    const handleReservedCancel = () => {
        setEditReservedId(null);
    };

    const reservedColumn = [
        { Header: "Part", accessor: "partName" },
        { Header: "Part Code", accessor: "partCode" },
        {
            Header: "Quantity",
            accessor: "quantity",
            Cell: ({ row }) => (
                editReservedId === row.original.id ? (
                    <TextField
                        type="number"
                        size="small"
                        value={editReservedQuantity}
                        onChange={e => setEditReservedQuantity(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                        sx={{ width: 80 }}
                    />
                ) : (
                    row.original.quantity
                )
            ),
        },
        {
            Header: "Stock Room",
            accessor: "stockRoomId",
            Cell: ({ row }) => (
                editReservedId === row.original.id ? (
                    <Autocomplete
                        size="small"
                        options={editReservedStockRoomOptions}
                        getOptionLabel={option => option.text || ""}
                        value={editReservedStockRoomOptions.find(s => s.value === editReservedStockRoomId) || null}
                        onChange={(e, value) => setEditReservedStockRoomId(value ? value.value : "")}
                        renderInput={params => <TextField {...params} placeholder="Stock Room" />}
                        sx={{ width: 150 }}
                    />
                ) : (
                    row.original.stockRoomName
                )
            ),
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: ({ row }) => (
                editReservedId === row.original.id ? (
                    <>
                        <Button size="small" color="primary" onClick={() => handleReservedSave(row.original)}>Save</Button>
                        <Button size="small" color="inherit" onClick={handleReservedCancel}>Cancel</Button>
                    </>
                ) : (
                    <IconButton onClick={() => handleReservedEdit(row.original)}>
                        <EditOutlined sx={{ fontSize: color.masterEditDelButton, color: color.masterEditDelButtonColor }} />
                    </IconButton>
                )
            ),
            disableFilters: true,
        },
    ];

    return (
        <Box sx={{ p: color.masterPageDialogPadding }}>
            <Dialog
                open={confirmDialog.open}
                onClose={handleCancelWorkOrderChange}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Work Order Change"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Changing or removing the Work Order will clear all items in the
                        Reservation Item List. Are you sure you want to proceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelWorkOrderChange} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmWorkOrderChange}
                        color="error"
                        variant="contained"
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        color: color.masterDialogTitleColor,
                        fontSize: color.masterDialogFontSize,
                    }}
                >
                    {mode === "Edit" ? "Edit Parts Reservation" : "New Parts Reservation"}
                </Typography>
                <IconButton onClick={handleCancel}>
                    <Clear />
                </IconButton>
            </Box>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />

            <Formik initialValues={initialValue} onSubmit={onSubmit}>
                {({ setFieldValue }) => (
                    <Form>
                        <Grid container spacing={"1rem"}>
                            {/* Work Order - Now at the top, outside tabs */}
                            <Grid item xs={12} md={6}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Work Order
                                </Typography>
                                <Autocomplete
                                    value={selectedWorkOrder}
                                    inputValue={woSel}
                                    fullWidth
                                    filterOptions={filterOptions}
                                    loading={woData.length === 0}
                                    options={woData}
                                    PaperComponent={CustomPaper}
                                    getOptionLabel={(option) =>
                                        option.code + " - " + option.workOrderName || option
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    onChange={(event, value) => {
                                        handleWorkOrderChange(event, value, setFieldValue);
                                    }}
                                    onInputChange={(event, newInputValue, reason) => {
                                        if (reason !== "reset") {
                                            setWOSel(newInputValue);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="workOrderId"
                                            placeholder="Select Work Order"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {woData.length === 0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Tabs */}
                            <Grid item xs={12}>
                                <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)}>
                                    <Tab label="New Reservation" />
                                    <Tab label="Reserved" />
                                </Tabs>
                            </Grid>

                            {activeTab === 0 && (
                                <>
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: color.masterDialogTitleColor,
                                                    fontSize: color.masterDialogFontSize,
                                                }}
                                            >
                                                Create Reservation Item
                                            </Typography>
                                            <IconButton
                                                sx={{ backgroundColor: color.TableButtonColor }}
                                                onClick={handleReservationList}
                                                disabled={!reservationItem.partId || !reservationItem.stockRoomId || reservationItem.quantity <= 0}
                                            >
                                                <Add sx={{ color: "white" }} />
                                            </IconButton>
                                        </Box>
                                        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
                                    </Grid>
                                    <Grid container item xs={12} spacing={"1rem"}>
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                sx={{
                                                    fontWeight: color.labelFontWeight,
                                                    mb: color.labelmb,
                                                    fontSize: color.labelFont,
                                                    color: color.labelColor,
                                                }}
                                            >
                                                Part
                                            </Typography>
                                            <Autocomplete
                                                value={workOrderParts.find(p => p.partId === reservationItem.partId) || null}
                                                inputValue={partSelect}
                                                fullWidth
                                                filterOptions={filterOptions}
                                                loading={loadingParts}
                                                options={workOrderParts}
                                                PaperComponent={CustomPaper}
                                                getOptionLabel={(option) =>
                                                    (option.code ? option.code + " - " : "") + option.partName || option
                                                }
                                                isOptionEqualToValue={(option, value) => option.partId === value?.partId}
                                                disabled={!selectedWorkOrder}
                                                onChange={(event, value) => {
                                                    if (value !== null) {
                                                        handlePart(value);
                                                        setPartSel((value.code ? value.code + " - " : "") + value.partName);
                                                    } else {
                                                        setPartSel("");
                                                        setReservationItem({
                                                            partId: null,
                                                            stockRoomId: null,
                                                            quantity: 0,
                                                            stockRoom: [],
                                                        });
                                                        setSRSel("");
                                                    }
                                                }}
                                                onInputChange={(event, newInputValue) => {
                                                    setPartSel(newInputValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="partId"
                                                        placeholder={selectedWorkOrder ? "Select Part" : "Select Work Order First"}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingParts ? (
                                                                        <CircularProgress color="inherit" size={20} />
                                                                    ) : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                sx={{
                                                    fontWeight: color.labelFontWeight,
                                                    mb: color.labelmb,
                                                    fontSize: color.labelFont,
                                                    color: color.labelColor,
                                                }}
                                            >
                                                Stock Room
                                            </Typography>
                                            <Autocomplete
                                                value={reservationItem.stockRoom.find(s => s.value === reservationItem.stockRoomId) || null}
                                                inputValue={srSelect}
                                                fullWidth
                                                filterOptions={filterOptions}
                                                options={reservationItem.stockRoom}
                                                PaperComponent={CustomPaper}
                                                getOptionLabel={(option) => option.text || option}
                                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                disabled={!reservationItem.partId}
                                                onChange={(event, value) => {
                                                    if (value !== null) {
                                                        handleStockRoom(value);
                                                        setSRSel(value.text);
                                                    } else {
                                                        setSRSel("");
                                                        setReservationItem({
                                                            ...reservationItem,
                                                            stockRoomId: null,
                                                        });
                                                    }
                                                }}
                                                onInputChange={(event, newInputValue) => {
                                                    setSRSel(newInputValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="stockRoomId"
                                                        placeholder={reservationItem.partId ? "Select Stock Room" : "Select Part First"}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        InputProps={{
                                                            ...params.InputProps,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                sx={{
                                                    fontWeight: color.labelFontWeight,
                                                    mb: color.labelmb,
                                                    fontSize: color.labelFont,
                                                    color: color.labelColor,
                                                }}
                                            >
                                                Quantity
                                            </Typography>
                                            <TextField
                                                size={"small"}
                                                type="number"
                                                name="quantity"
                                                value={reservationItem.quantity}
                                                placeholder="Enter Quantity"
                                                fullWidth
                                                onChange={handleAddReservation}
                                                sx={{
                                                    ".MuiInputBase-input": {
                                                        "&::placeholder": {
                                                            opacity: 1,
                                                            color: color.placeholderColor,
                                                            fontSize: "13px",
                                                        },
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: color.masterDialogTitleColor,
                                                    fontSize: color.masterDialogFontSize,
                                                }}
                                            >
                                                Reservation Item List
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <NormalTable data={addReservation} columns={partColumn} filt={true} />
                                    </Grid>
                                </>
                            )}
                            {activeTab === 1 && (
                                <Grid item xs={12}>
                                    {reservedList.length > 0 ? (
                                        <Box sx={{ mt: 2 }}>
                                            <Typography sx={{ color: color.masterDialogTitleColor, fontSize: color.masterDialogFontSize }}>
                                                Reserved List for Selected Work Order
                                            </Typography>
                                            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
                                            <NormalTable data={reservedList} columns={reservedColumn} filt={true} />
                                        </Box>
                                    ) : (
                                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                                            <Typography color="textSecondary">
                                                {selectedWorkOrder ? "No reserved items found for this work order." : "Please select a work order to view reserved items."}
                                            </Typography>
                                        </Box>
                                    )}
                                </Grid>
                            )}
                            <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                                <Button
                                    onClick={handleCancel}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: color.TableCancelButton,
                                        textTransform: "none",
                                        color: color.CancelTextColor,
                                        ":hover": {
                                            backgroundColor: color.TableCancelButton,
                                            textTransform: "none",
                                            color: color.CancelTextColor,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                {activeTab === 0 && (
                                    <Button
                                        type={"submit"}
                                        variant="contained"
                                        disabled={loading || addReservation.length === 0}
                                        sx={{
                                            textTransform: "none",
                                            backgroundColor: loading
                                                ? "default"
                                                : color.TableButtonColor,
                                            "&:hover": {
                                                backgroundColor: loading
                                                    ? "default"
                                                    : color.buttonDisable,
                                            },
                                        }}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default PartsReservationModal;